import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

import { Container } from "../global"

const Footer = () => (
  <FooterWrapper id="footer">
    <FooterColumnContainer>
      <FooterColumn>
        <span>Day ☀️</span>
        <ul>
          <li>The sun rises anyway.</li>
          <li>
            <a href="/#how-it-works">How Day Works</a>
          </li>
          <li>
            <a href="/#faq">FAQ</a>
          </li>
        </ul>
      </FooterColumn>
      <FooterColumn>
        <span>Legal</span>
        <ul>
          <li>
            <Link to="/privacy">Privacy Policy</Link>
          </li>
          <li>
            <Link to="/terms">Terms of Service</Link>
          </li>
        </ul>
      </FooterColumn>
      <FooterColumn>
        <span>Support</span>
        <ul>
          <li>
            <Link to="/subscriptions">Support Our Community</Link>
          </li>
          <li>
            <a href="mailto:theschnaz@gmail.com">Contact Us</a>
          </li>
        </ul>
      </FooterColumn>
      <FooterColumn>
        <span>Follow along</span>
        <ul>
          <li>
            <a
              href="https://www.twitter.com/theschnaz"
              target="_blank"
              rel="noopener noreferrer"
            >
              @TheSchnaz on X
            </a>
          </li>
          <li>
            <Link to="/whitepaper">Whitepapers</Link>
          </li>
          <li>
            <a
              href="https://www.stitcher.com/show/the-nobcast/episode/ep-23-earn-bitcoin-in-your-daily-practice-with-the-dailyness-app-featuring-the-schnaz-202398772"
              target="_blank"
              rel="noopener noreferrer"
            >
              TheSchnaz on The Nobcast
            </a>
          </li>
        </ul>
      </FooterColumn>
    </FooterColumnContainer>
  </FooterWrapper>
)

const FooterWrapper = styled.footer`
  padding: 80px;
  background: linear-gradient(180deg, #fffdf8 0%, #fff4e3 100%);
  @media (max-width: ${(props) => props.theme.screen.sm}) {
    padding: 60px 32px;
  }
`
const FooterColumnContainer = styled(Container)`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 32px;
  justify-content: start;
  @media (max-width: ${(props) => props.theme.screen.sm}) {
    grid-template-columns: 1fr 1fr;
    grid-gap: 32px;
  }
`
const FooterColumn = styled.div`
  span {
    font-size: 16px;
    font-family: ${(props) => props.theme.font.bold};
    color: ${(props) => props.theme.color.primary};
  }
  ul {
    list-style: none;
    margin: 16px 0;
    padding: 0;
    color: ${(props) => props.theme.color.black.regular};
    li {
      margin-bottom: 12px;
      font-family: ${(props) => props.theme.font.normal};
      font-size: 15px;
    }
  }
  a {
    color: ${(props) => props.theme.color.black.regular};
    text-decoration: none;

    &:hover {
      color: ${(props) => props.theme.color.accent};
    }
  }
`

export default Footer
